export const clearUrlHash = {
  beforeCreate() {
    if (window.location.hash != null) window.location.hash = '#';
  },
};

export default clearUrlHash;
